import type { FairSibling } from '../types/api';

/**
 * Flags that ship with the app, used when the API has no icon for a fair.
 * Falls back to the code so an unmapped country still renders.
 */
export function flagUrl(countryId: string | undefined): string {
  return `/assets/flags/${countryId ?? 'hr'}.svg`;
}

/**
 * The flag for one sibling fair.
 *
 * `iconUrl` first: the `country` relation is not populated on siblings, so
 * deriving the flag from `country.id` fell back to the same default for every
 * entry and drew four identical Croatian flags.
 */
export function siblingFlagUrl(sibling: FairSibling | undefined): string {
  return sibling?.iconUrl ?? flagUrl(sibling?.country?.id);
}
